module.exports = __webpack_public_path__ + "66277f79b9dcf856195b0e41c0ee4a9d.svg";